import { io } from "socket.io-client";

const USER_API_BASE = process.env.REACT_APP_USER_API_URL || "http://localhost:5000/api";

// Auto-upgrade to wss:// / https:// when page is served over HTTPS (mixed-content fix).
// S3 / CloudFront serve over HTTPS, but the backend IP is plain HTTP — this bridges the gap.
function upgradeToSecureIfNeeded(url) {
  if (typeof window !== "undefined" && window.location.protocol === "https:") {
    return url.replace(/^http:\/\//i, "https://").replace(/^ws:\/\//i, "wss://");
  }
  return url;
}

const SOCKET_BASE = upgradeToSecureIfNeeded(USER_API_BASE.replace(/\/api\/?$/, ""));

// ── Chat socket (one-off per chat session, unchanged) ──────────────────────
export function createChatSocket(token) {
  return io(SOCKET_BASE, {
    path: "/api/socket.io/",
    transports: ["websocket"],
    withCredentials: true,
    auth: { token: `Bearer ${token}` },
  });
}

// ── Booking socket (singleton per token — reused across the app) ───────────
let _bookingSocket = null;
let _bookingSocketToken = null;

export function getBookingSocket(token) {
  // Return the existing socket if the token is the same and it's still connected.
  if (_bookingSocket && _bookingSocketToken === token && _bookingSocket.connected) {
    return _bookingSocket;
  }

  // Tear down any stale socket before creating a new one.
  if (_bookingSocket) {
    _bookingSocket.disconnect();
    _bookingSocket = null;
    _bookingSocketToken = null;
  }

  _bookingSocket = io(SOCKET_BASE, {
    path: "/api/socket.io/",
    transports: ["websocket"],
    withCredentials: true,
    auth: { token: `Bearer ${token}` },
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 2000,
  });

  _bookingSocketToken = token;
  return _bookingSocket;
}

export function destroyBookingSocket() {
  if (_bookingSocket) {
    _bookingSocket.disconnect();
    _bookingSocket = null;
    _bookingSocketToken = null;
  }
}
